import { createContext, useContext, useEffect, useState } from "react";
import { http } from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const check = async () => {
    try { setUser((await http.get("/auth/me")).data); }
    catch {
      try { await http.post("/auth/refresh"); setUser((await http.get("/auth/me")).data); } catch { setUser(false); }
    }
  };
  useEffect(() => { check(); }, []);
  const login = async (email, password) => { const { data } = await http.post("/auth/login", { email, password }); setUser(data); return data; };
  const logout = async () => { await http.post("/auth/logout"); setUser(false); };
  return <AuthCtx.Provider value={{ user, login, logout }}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);
